import { Navbar } from "@/components/Navbar";
import { LiveBroadcast } from "@/components/LiveBroadcast";
import { Footer } from "@/components/Footer";

export default function Direct() {
  return (
    <div className="grain relative bg-theatre-ink min-h-screen" data-testid="direct-page">
      <Navbar />
      <main className="pt-20">
        <LiveBroadcast />
      </main>
      <Footer />
    </div>
  );
}
